import { AdSpaceEnum, AdsPricing } from "./Advert";

export interface AdsCoupon {
	Code: string;
	CodeFormatted: string;
	AdSpace: AdSpaceEnum;
	AdsPricing: AdsPricing;
	Amount: number;
	DurationInDaysLimit: number;
	PosterLimit: number;
	DateCreatedUtc: string;
	CreatedByUserId: string;
	Redeemed: boolean;
	RedeemedDateUtc: string;
	RedeemedUserId: string;
}


export class CreateAdsCouponModel {
	AdSpace: AdSpaceEnum;
	Amount: number;
	PercentageDiscount: number;
	PosterLimit: number;
	DurationInDaysLimit: number;
}

export class EditAdsCouponModel extends CreateAdsCouponModel {
	Code: string;
	constructor(item?: AdsCoupon) {
		super();
		this.Code = item && item.Code;
		this.AdSpace = item && item.AdsPricing.Id;
		this.Amount = item && item.Amount;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/adsCoupon.ts